const baseURL = 'www.baidu.com'
const token = '123456'
const userSite = '林花落了春红，太匆匆'
const testSocketUrl = 'http://172.16.1.21:8010/webSocket'
const devSocketUrl = 'http://localhost:8010/webSocket'
const proSocketUrl = 'http://172.16.1.21:8010/webSocket'
export default {
    baseURL,
    token,
    userSite,
    testSocketUrl,
    devSocketUrl,
    proSocketUrl,
}
